type DetectOS = {
  isIOS: boolean;
  isAndroid: boolean;
};

export const detectOS = (): DetectOS => {
  const { userAgent } = window.navigator;
  const isIOS = /iPhone|iPad|iPod/gi.test(userAgent) && !window.MSStream;
  const isAndroid = /Android/gi.test(userAgent);

  return { isIOS, isAndroid };
};
